export default __webpack_public_path__ + "static/media/emerging-factor-tree.aec52f94.svg";